import React from "react";
import { useTranslation } from "react-i18next";

interface BookingSummaryProps {
  selectedDate: string;
  selectedTime: string;
  selectedDuration: number;
  selectedGuests: number;
  onGoToStep: (step: number) => void;
  onConfirm: () => void;
}

export const BookingSummary: React.FC<BookingSummaryProps> = ({
  selectedDate,
  selectedTime,
  selectedDuration,
  selectedGuests,
  onGoToStep,
  onConfirm,
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="p-4 sm:p-6 space-y-6">
      <h3 className="text-xs uppercase tracking-[0.2em] text-amber-700 dark:text-amber-400 font-serif font-bold">
        {t("booking.summaryTitle", "Podsumowanie rezerwacji")}
      </h3>

      <div className="bg-white dark:bg-stone-950 p-5 rounded-2xl space-y-4 border border-stone-200 dark:border-amber-500/20 shadow-lg text-xs font-serif">
        <div className="flex justify-between items-center border-b border-stone-200 dark:border-stone-800/80 pb-3">
          <span className="text-stone-500 dark:text-stone-400">
            {t("booking.date", "Data")}:
          </span>
          <div className="flex items-center space-x-3">
            <span className="font-bold text-stone-900 dark:text-stone-100">
              {selectedDate}
            </span>
            <button
              onClick={() => onGoToStep(1)}
              className="text-[11px] text-amber-600 dark:text-amber-400 hover:underline cursor-pointer"
            >
              {t("booking.change", "Zmień")}
            </button>
          </div>
        </div>

        <div className="flex justify-between items-center border-b border-stone-200 dark:border-stone-800/80 pb-3">
          <span className="text-stone-500 dark:text-stone-400">
            {t("booking.time", "Godzina")}:
          </span>
          <div className="flex items-center space-x-3">
            <span className="font-bold text-stone-900 dark:text-stone-100">
              {selectedTime}
            </span>
            <button
              onClick={() => onGoToStep(3)}
              className="text-[11px] text-amber-600 dark:text-amber-400 hover:underline cursor-pointer"
            >
              {t("booking.change", "Zmień")}
            </button>
          </div>
        </div>

        <div className="flex justify-between items-center border-b border-stone-200 dark:border-stone-800/80 pb-3">
          <span className="text-stone-500 dark:text-stone-400">
            {t("booking.duration", "Czas trwania")}:
          </span>
          <div className="flex items-center space-x-3">
            <span className="font-bold text-stone-900 dark:text-stone-100">
              {selectedDuration} {t("booking.minUnit", "min")}
            </span>
            <button
              onClick={() => onGoToStep(4)}
              className="text-[11px] text-amber-600 dark:text-amber-400 hover:underline cursor-pointer"
            >
              {t("booking.change", "Zmień")}
            </button>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-stone-500 dark:text-stone-400">
            {t("booking.guests", "Liczba osób")}:
          </span>
          <div className="flex items-center space-x-3">
            <span className="font-bold text-stone-900 dark:text-stone-100">
              {selectedGuests}
            </span>
            <button
              onClick={() => onGoToStep(5)}
              className="text-[11px] text-amber-600 dark:text-amber-400 hover:underline cursor-pointer"
            >
              {t("booking.change", "Zmień")}
            </button>
          </div>
        </div>
      </div>

      <button
        onClick={onConfirm}
        className="w-full py-4 bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-500 hover:to-amber-600 text-white font-serif text-xs font-semibold uppercase tracking-widest rounded-xl transition-all duration-200 shadow-lg shadow-amber-950/40 border border-amber-400/20 cursor-pointer"
      >
        {t("booking.confirmOrder", "Potwierdź rezerwację")}
      </button>
    </div>
  );
};
